import * as angular from "angular";
import {encodeUriComponentFilterFactory} from "./encodeUriComponent.filter";
import {yesNoFilterFactory} from "./yesNo.filter";

export const FilterModule = angular.module("app.shared.filter", [])

    .filter("encodeURIComponent", encodeUriComponentFilterFactory)
    .filter("yesNo", yesNoFilterFactory)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/filter/filter.module.ts